/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs */

const en_admin_external_booking_edit_invalid_date_range_day = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end date must be on or after the start date.`)
};

const de_admin_external_booking_edit_invalid_date_range_day = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Enddatum muss am oder nach dem Startdatum liegen.`)
};

const es_admin_external_booking_edit_invalid_date_range_day = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha de fin debe ser igual o posterior a la fecha de inicio.`)
};

const fr_admin_external_booking_edit_invalid_date_range_day = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La date de fin doit être égale ou postérieure à la date de début.`)
};

const nl_admin_external_booking_edit_invalid_date_range_day = /** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De einddatum moet op of na de startdatum liggen.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */
const it_admin_external_booking_edit_invalid_date_range_day = en_admin_external_booking_edit_invalid_date_range_day;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_invalid_date_range_day = en_admin_external_booking_edit_invalid_date_range_day;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */
const pl_admin_external_booking_edit_invalid_date_range_day = en_admin_external_booking_edit_invalid_date_range_day;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */
const hu_admin_external_booking_edit_invalid_date_range_day = en_admin_external_booking_edit_invalid_date_range_day;

/** @type {(inputs: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs) => LocalizedString} */
const ro_admin_external_booking_edit_invalid_date_range_day = en_admin_external_booking_edit_invalid_date_range_day;

/**
* | output |
* | --- |
* | "The end date must be on or after the start date." |
*
* @param {Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_invalid_date_range_day = /** @type {((inputs?: Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Invalid_Date_Range_DayInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "de") return de_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "es") return es_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "it") return it_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_invalid_date_range_day(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_invalid_date_range_day(inputs)
	return ro_admin_external_booking_edit_invalid_date_range_day(inputs)
});
export { admin_external_booking_edit_invalid_date_range_day as "admin.external_booking_edit.invalid_date_range_day" }